import { render } from "./RouteRooms.vue?vue&type=template&id=ed894ac8&scoped=true&ts=true"
import script from "./RouteRooms.vue?vue&type=script&lang=ts"
export * from "./RouteRooms.vue?vue&type=script&lang=ts"

import "./RouteRooms.vue?vue&type=style&index=0&id=ed894ac8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed894ac8"]])

export default __exports__